export const DEFAULT_VENDING_BIN_COUNT = 24;
export const VENDING_BIN_COUNT_ERROR = 'Vending bin count must be between 1 and 500.';

export const parseVendingBinCount = (value: string): number | null => {
  const trimmedValue = value.trim();
  if (!/^\d+$/.test(trimmedValue)) {
    return null;
  }

  const binCount = Number(trimmedValue);
  return binCount >= 1 && binCount <= 500 ? binCount : null;
};
